var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.86913H3C2.73478 4.86913 2.48043 4.97448 2.29289 5.16202C2.10536 5.34956 2 5.60391 2 5.86913V19.8691C2 20.1343 2.10536 20.3887 2.29289 20.5762C2.48043 20.7638 2.73478 20.8691 3 20.8691H21C21.2652 20.8691 21.5196 20.7638 21.7071 20.5762C21.8946 20.3887 22 20.1343 22 19.8691V5.86913C22 5.60391 21.8946 5.34956 21.7071 5.16202C21.5196 4.97448 21.2652 4.86913 21 4.86913V4.86913ZM20 15.8691C19.2044 15.8691 18.4413 16.1852 17.8787 16.7478C17.3161 17.3104 17 18.0735 17 18.8691H7C7 18.0735 6.68393 17.3104 6.12132 16.7478C5.55871 16.1852 4.79565 15.8691 4 15.8691V9.86913C4.79565 9.86913 5.55871 9.55306 6.12132 8.99045C6.68393 8.42784 7 7.66477 7 6.86913H17C17 7.66477 17.3161 8.42784 17.8787 8.99045C18.4413 9.55306 19.2044 9.86913 20 9.86913V15.8691Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.86913C9.794 8.86913 8 10.6631 8 12.8691C8 15.0751 9.794 16.8691 12 16.8691C14.206 16.8691 16 15.0751 16 12.8691C16 10.6631 14.206 8.86913 12 8.86913ZM12 14.8691C10.897 14.8691 10 13.9721 10 12.8691C10 11.7661 10.897 10.8691 12 10.8691C13.103 10.8691 14 11.7661 14 12.8691C14 13.9721 13.103 14.8691 12 14.8691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.214226e0e76f8dcb7a04711535983854.svg";
export { ForwardRef as ReactComponent };